import React from 'react';

import { ButtonGroup } from '../../../Button/ButtonGroup';
import { FRAGMENT_BOND_MODE } from '../../etc/constants';
import { Fragment } from './components/Fragment';
import { FragmentPicker } from './components/FragmentPicker';
import { CommonMol, getCommonMols } from './services/getCommonMols';

const fragmentList = [
  'Pyrrole',
  'Benzene',
  'Cyclopropane',
  'Cyclobutane',
  'Cyclopentane',
  'Cyclohexane',
  'Cycloheptane',
  'Cyclopentadiene',
];

const commonMols = getCommonMols();
const commonFragmentMols = commonMols.filter(mol => fragmentList.includes(String(mol.key)));

type CommonFragmentsProps = {
  onPickAtom: (mol: CommonMol, defaultIdx: string) => void;
  onPickBond: (mol: CommonMol, defaultIdx: string) => void;
  mode: any;
};
export const CommonFragments = React.memo(({ onPickAtom, onPickBond, mode }: CommonFragmentsProps) => {
  return (
    <ButtonGroup direction="column">
      {commonFragmentMols.map((mol, idx) => (
        <Fragment
          key={mol.key}
          mol={mol}
          size={30}
          onPickAtom={onPickAtom}
          onPickBond={onPickBond}
          active={mode.type === FRAGMENT_BOND_MODE && mode.data.fragment.key === mol.key}
          renderDelay={idx * 30}
        />
      ))}
      <FragmentPicker mols={commonMols} onPickAtom={onPickAtom} onPickBond={onPickBond} />
    </ButtonGroup>
  );
});
